import { render, staticRenderFns } from "./TriannualDeterminationProccessMain.vue?vue&type=template&id=82481fe8"
import script from "./TriannualDeterminationProccessMain.vue?vue&type=script&lang=js"
export * from "./TriannualDeterminationProccessMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports